import "rxjs/add/operator/mergeMap";
import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";
import { filter, isObject, pick } from "lodash";
import * as dayjs from "dayjs";

export default (action$) =>
  action$.ofType(Types.UN_GROUP_REGISTRATION).mergeMap(async (action) => {
    try {
      const registrationToUnGroup = cloneDeep(action.registration);
      const registrationsToRecreate = registrationToUnGroup.group
        .filter((_) => isObject(_.registration))
        .map((_) => ({ registrationId: _.registrationId, ..._.registration }));
      const minorsToRecreate = registrationToUnGroup.group.filter(
        (_) => _.minor && !!_.registrationId
      );
      registrationToUnGroup.group = registrationToUnGroup.group.filter(
        (_) => !_.registrationId
      );

      await firebase
        .database()
        .ref(
          `queues/${action.location}/${registrationToUnGroup.registrationId}`
        )
        .update(omit(registrationToUnGroup, ["registrationId"]));

      for (const registration of registrationsToRecreate) {
        const registrationRef = await firebase
          .database()
          .ref(`registrations`)
          .push(omit(registration, ["registrationId"]));

        const registrationId = registrationRef.key;
        let group = [];
        // Build our group, the first member of the group is who registered.
        const primary = {
          firstName: registration.firstName,
          lastName: registration.lastName,
          flaggedQuestions: filter(registration.questionnaire, (q) => {
            return q.negativeIndicator === q.answer;
          }),
          minor: false,
          member: registration.member || false,
          active: registration.active || false,
          ...(registration.member === true && {
            sku: registration.sku,
            type: registration.type,
          }),
          customer: registration.customer,
          issues: registration.issues || [],
        };

        let flagged =
          (primary.flaggedQuestions && primary.flaggedQuestions.length > 0) ||
          (primary.issues && primary.issues.length > 0);
        if (primary.active && primary.member && primary.type) {
          const [memberTier] = primary.type.split(" ");
          if (memberTier.toLowerCase() === "junior") {
            const birthdayDate = dayjs(
              `${registration.dateOfBirth.month}/${registration.dateOfBirth.day}/${registration.dateOfBirth.year}`
            );

            const memberAge = dayjs().diff(birthdayDate, "year", true);

            flagged = flagged || memberAge > 30;

            primary.flaggedMembershipMessages =
              memberAge > 30
                ? [
                    "Member's age exceeds the maximum for this membership type > 30 years of age",
                  ]
                : [];
          }
        }
        group.push(primary);
        const minors = minorsToRecreate
          .filter((_) => _.registrationId === registration.registrationId)
          .map((_) => omit(_, ["registrationId"]));

        flagged =
          flagged ||
          minors.some(
            (minor) =>
              minor.flaggedQuestions && minor.flaggedQuestions.length > 0
          );

        group = group.concat(minors);

        const queueRef = await firebase
          .database()
          .ref(`queues/${action.location}`)
          .push({
            ...pick(registration, ["active", "ranges", "member", "rental"]),
            flagged: flagged,
            group: group,
            registration: registrationId,
            timestamp: new Date().getTime(),
          });
        await registrationRef.update({
          activeRegistration: registrationId,
          queueId: queueRef.key,
        });
        if (registration.customer) {
          await firebase
            .database()
            .ref(`customers/${registration.customer}`)
            .update({
              activeRegistration: registrationId,
            });
        }
      }

      return Creators.unGroupRegistrationSucceeded();
    } catch (error) {
      console.error(error);
      return Creators.unGroupRegistrationFailed();
    }
  });



// WEBPACK FOOTER //
// ./src/staff/epics/unGroupRegistration.js